export const appStoreLinks = {
    android: "https://play.google.com/store/apps/details?id=de.farmact.app",
    ios: "https://apps.apple.com/de/app/farmact/id1512737887",
};
